module.exports = __webpack_public_path__ + "static/media/Canvas_508-01.b37a90de.jpg";